var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.enable
    ? _c("div", { staticClass: "pagination-bar" }, [
        _vm.isMobile && _vm.conf.mobile.enable
          ? _c("nav", [
              _c(
                "ul",
                { staticClass: "pagination pagination-lg p-center d-sm-none" },
                [
                  _vm.conf.showNextPrevious && 1 !== _vm.currentPage
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(_vm.currentPage - 1)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "fa fa-chevron-left" }),
                            _vm._v(" "),
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.$t("messages_nl.global.previous"))
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conf.showNextPrevious && _vm.lastPage !== _vm.currentPage
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(_vm.currentPage + 1)
                              },
                            },
                          },
                          [
                            _c("span", [
                              _vm._v(_vm._s(_vm.$t("messages_nl.global.next"))),
                            ]),
                            _vm._v(" "),
                            _c("i", { staticClass: "fa fa-chevron-right" }),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
            ])
          : _c("nav", [
              _c(
                "ul",
                {
                  staticClass:
                    "advanced pagination pagination-lg d-none d-sm-flex",
                },
                [
                  _vm.conf.showNextPrevious && 1 !== _vm.currentPage
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(_vm.currentPage - 1)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-chevron-left" })]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conf.showFirstPage && !_vm.atStart
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(1)
                              },
                            },
                          },
                          [_vm._v("1")]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conf.showFirstPage && !_vm.atStart
                    ? _c("li", [
                        _c("span", { staticClass: "page-link" }, [
                          _vm._v("..."),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm._l(_vm.pageNumbers, function (page) {
                    return _c(
                      "li",
                      {
                        key: page,
                        class: [
                          "page-item",
                          { active: page === _vm.currentPage },
                        ],
                      },
                      [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(page)
                              },
                            },
                          },
                          [_vm._v(_vm._s(page))]
                        ),
                      ]
                    )
                  }),
                  _vm._v(" "),
                  _vm.conf.showLastPage && !_vm.atEnd
                    ? _c("li", [
                        _c("span", { staticClass: "page-link" }, [
                          _vm._v("..."),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conf.showLastPage && !_vm.atEnd
                    ? _c("li", { staticClass: "page-item" }, [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(_vm.lastPage)
                              },
                            },
                          },
                          [_vm._v(_vm._s(_vm.lastPage))]
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.conf.showNextPrevious && _vm.lastPage !== _vm.currentPage
                    ? _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "page-link",
                            on: {
                              click: function ($event) {
                                return _vm.updatePage(_vm.currentPage + 1)
                              },
                            },
                          },
                          [_c("i", { staticClass: "fa fa-chevron-right" })]
                        ),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }